import { Autocomplete, AutocompleteProps } from '@mui/material';

export type SelectProps<
  T,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
> = AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>;

export const Select = <
  T,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
>(
  props: SelectProps<T, Multiple, DisableClearable, FreeSolo>,
) => {
  return <Autocomplete {...props} />;
};
